/**
 * Payer Connections — API surface (AC-2, AC-4, AC-9).
 *
 * Generated reads only: no enrollment mutation or sync-all endpoint.
 * Mount freshness and scope changes use the query's fetching state; Stedi
 * connection tags refresh mounted reads after the account key changes.
 */

import { enhancedApi as enrollmentsGeneratedApi } from '@store/generated/enrollments';

// Match Stedi connection mutations' existing tags so mounted enrollment reads
// refresh as soon as the selected organization connects or reconnects.
export const payerConnectionsApi = enrollmentsGeneratedApi.enhanceEndpoints({
  addTagTypes: ['StediConnection'],
  endpoints: {
    getV2ProviderEnrollmentsLive: {
      providesTags: [{ type: 'StediConnection', id: 'PROVIDER' }],
    },
    getV2AdminOrgsByOrganizationIdEnrollmentsLive: {
      providesTags: (_result, _error, arg) => [{ type: 'StediConnection', id: arg.organizationId }],
    },
  },
});

export const {
  useGetV2ProviderEnrollmentsLiveQuery: usePayerConnectionsLiveQuery,
  useGetV2AdminOrgsByOrganizationIdEnrollmentsLiveQuery: useAdminPayerConnectionsLiveQuery,
} = payerConnectionsApi;
